import styled from 'styled-components'

export const PrintContainer = styled.div`
  @media screen {
    overflow: scroll;
  }
`

export const MainTable = styled.table`
  width: 800px;
`

export const SpacerCell = styled.td`
  width: 75px;
  height: 20px;
  vertical-align: top;
`

export const MainContentCell = styled.td`
  vertical-align: top;
`

export const ControlsSection = styled.div`
  margin-bottom: 14px;
  @media print {
    display: none;
  }
`

export const PrintButton = styled.input`
  font-family: Verdana;
  font-size: 10px;
  font-weight: bold;
  background: #dddddd;
  border-bottom: 1px solid #00214c;
  border-right: 1px solid #00214c;
  border-left: 1px solid #00214c;
  border-top: 1px solid #00214c;
  color: #000000;
  height: 20px;
  text-decoration: none;
  cursor: pointer;
  margin-right: 4px;
`

export const PDFButton = styled.input`
  font-family: Verdana;
  font-size: 10px;
  font-weight: bold;
  background: #dddddd;
  border-bottom: 1px solid #00214c;
  border-right: 1px solid #00214c;
  border-left: 1px solid #00214c;
  border-top: 1px solid #00214c;
  color: #000000;
  height: 20px;
  text-decoration: none;
  cursor: pointer;
  margin-right: 4px;
  margin-bottom: 20px;
`

export const CheckboxLabel = styled.label`
  font-family: Verdana;
  font-size: 10px;
  font-weight: normal;
  padding-right: 0px;
  padding-left: 0px;
  padding-bottom: 0px;
  margin: 0px;
  padding-top: 0px;
  height: 10px;
`

export const PrintDiv = styled.div`
  overflow: auto;
  height: 100%;
`

export const ContentTable = styled.table`
  border: 0;
  width: 600px;
`

export const LogoCell = styled.td`
  position: relative;
`

export const ScaniaLogo = styled.img`
  width: 169px;
  height: 28px;
  border-width: 0px;
`

export const ScaniaIcon = styled.img`
  width: 48px;
  height: 46px;
  border-width: 0px;
`

export const HeaderCell = styled.td``

export const HeaderTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const SubHeaderTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const HrSeparator = styled.hr`
  /* hr-separator styles if needed */
`

export const InfoTable = styled.table`
  width: 600px;
`

export const InfoLabelCell = styled.td<{ width: string }>`
  width: ${props => props.width};
`

export const InfoValueCell = styled.td<{ width: string }>`
  width: ${props => props.width};
  border-bottom: 1px solid #000000;
`

export const InfoSpacerCell = styled.td<{ width: string }>`
  width: ${props => props.width};
`

export const MiniText = styled.span`
  font-weight: normal;
  font-size: 10px;
  color: #000000;
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const PledgesTable = styled.table`
  width: 600px;
  padding-top: 5px;
`

export const PledgeSpacerRow = styled.tr``

export const PledgeSpacerCell = styled.td<{ width: string }>`
  width: ${props => props.width};
  vertical-align: top;
`

export const PledgeHeaderRow = styled.tr`
  width: 600px;
`

export const PledgeHeaderCell = styled.td`
  padding: 0;
`

export const PledgeInnerTable = styled.table`
  width: 600px;
  border-collapse: collapse;
`

export const PledgeNumberCell = styled.td`
  background-color: #dddddd;
  width: 15px;
  text-align: left;
  font-size: 12px;
  padding: 2px;
  border: 1px solid #000;
  font-family: Verdana, Arial;
  border-right: none;
`

export const PledgeDescriptionCell = styled.td`
  width: 585px;
  font-weight: bolder;
  font-size: 16px;
  padding: 2px;
  border: 1px solid #000;
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const PledgeNoteRow = styled.tr``

export const PledgeNoteCell = styled.td`
  background-color: white;
  padding: 4px;
`

export const PledgeNoteHeaderSpan = styled.span`
  font-family: Verdana;
  font-size: 12px;
  color: #000000;
  font-weight: bold;
`

export const PledgeNoteContentSpan = styled.span`
  font-family: Verdana;
  font-size: 10px;
  color: #000000;
`

export const PerspectiveRow = styled.tr``

export const PerspectiveCell = styled.td`
  width: 585px;
  font-weight: bolder;
  font-size: 11px;
  color: #000000;
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const PerspectiveTable = styled.table`
  margin-top: 8px;
  border: 1px solid;
  width: 585px;
`

export const PerspectiveHeaderCell = styled.td`
  padding: 4px;
  vertical-align: middle;
  font-size: 11px;
  width: 585px;
  background-color: #dddddd;
`

export const PerspectiveContentCell = styled.td`
  padding: 4px;
  vertical-align: middle;
  font-size: 11px;
  width: 585px;
`

export const AuditPointsHeaderCell = styled.td`
  background-color: white;
`

export const AuditPointsHeaderTable = styled.table`
  width: 600px;
  border-collapse: collapse;
  border-style: none;
`

export const AuditPointsHeaderRow = styled.tr`
  background-color: #ffffff;
`

export const HeaderColumnCell = styled.td<{ width: string }>`
  font-weight: bold;
  font-size: 11px;
  padding: 4px;
  width: ${props => props.width};
  text-align: center;
`

export const AuditPointRow = styled.tr`
  padding: 0;
`

export const AuditPointNumberCell = styled.td`
  width: 15px;
  padding-top: 8px;
`

export const AuditPointContentCell = styled.td<{ isMandatory: boolean }>`
  width: 585px;
  font-weight: bolder;
  font-size: 11px;
  padding-top: 8px;
  color: ${props => (props.isMandatory ? '#000000' : 'Gray')};
  font-style: ${props => (props.isMandatory ? 'normal' : 'italic')};
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const AuditPointTable = styled.table`
  border: 0;
  width: 585px;
`

export const AuditPointDescriptionCell = styled.td`
  width: 439px;
`

export const CheckboxCell = styled.td`
  width: 43px;
  text-align: center;
  vertical-align: top;
`

export const DocumentsCell = styled.td`
  width: 60px;
  text-align: center;
  vertical-align: top;
`

export const CheckboxImage = styled.img``

export const InfoImage = styled.img``

export const CheckPointRow = styled.tr``

export const CheckPointSpacerCell = styled.td`
  width: 15px;
  padding-bottom: 2px;
  padding-top: 2px;
`

export const CheckPointContentCell = styled.td<{ isMandatory: boolean }>`
  width: 585px;
  font-size: 9px;
  margin-left: 10px;
  padding-bottom: 2px;
  padding-top: 2px;
  color: ${props => (props.isMandatory ? '#000000' : 'Gray')};
  font-style: ${props => (props.isMandatory ? 'normal' : 'italic')};
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const CheckPointTable = styled.table`
  border: 0;
  width: 585px;
`

export const CheckPointSpacerTableCell = styled.td`
  width: 8px;
`

export const CheckPointDescriptionCell = styled.td`
  width: 431px;
  vertical-align: top;
`

export const CheckPointCheckboxCell = styled.td`
  width: 43px;
  text-align: center;
  vertical-align: middle;
`

export const CheckPointDocumentsCell = styled.td`
  width: 60px;
  text-align: center;
  vertical-align: middle;
`

export const NotesRow = styled.tr``

export const NotesCell = styled.td`
  width: 585px;
  font-weight: bolder;
  font-size: 11px;
  color: #000000;
  font-family: Trebuchet MS, Verdana, Arial, Geneva, Lucida;
`

export const NotesTable = styled.table`
  margin-top: 8px;
  border: 1px solid;
  width: 585px;
`

export const NotesHeaderCell = styled.td<{ width: string }>`
  vertical-align: middle;
  font-size: 11px;
  width: ${props => props.width};
  background-color: #dddddd;
`

export const NotesContentCell = styled.td`
  font-weight: normal;
`

export const SummaryRow = styled.tr`
  page-break-after: always;
`

export const SummaryMainTable = styled.table``

export const SummaryContentRow = styled.tr``

export const SummaryContentCell = styled.td`
  width: 600px;
  vertical-align: top;
`

export const SummaryTable = styled.table`
  border-width: 1px;
  border-style: solid;
  border-color: grey;
  border-collapse: collapse;
  width: 600px;
  font-family: Trebuchet MS, Verdana;
  font-size: 12px;
`

export const ActionPlansTable = styled.table`
  border-width: 1px;
  border-collapse: collapse;
  width: 600px;
  font-family: Trebuchet MS, Verdana;
  font-size: 12px;
`

export const ActionPlanRowHeader = styled.tr`
  font-weight: bold;
  background-color: #dddddd;
  font-style: normal;
  color: black;
`
export const ActionPlanRow = styled.tr`
  font-weight: normal;
  background-color: #dddddd;
  font-style: normal;
`

export const ActionPlanCell = styled.td`
  background-color: white;
  border-color: grey;
  border-width: 1px;
  border-style: solid;
`

export const ActionPlanHeaderCell = styled.td`
  border-color: grey;
  border-width: 1px;
  border-style: solid;
`
export const SummaryHeaderRow = styled.tr`
  background-color: #dddddd;
`

export const SummaryHeaderCell = styled.td<{ width?: string }>`
  font-weight: bold;
  text-align: center;
  border: 1px solid grey;
  width: ${props => props.width || 'auto'};
`

export const SummaryDataRow = styled.tr<{ isEven: boolean }>`
  background-color: ${props => (props.isEven ? '#FFFFFF' : '#DDDDDD')};
`

export const SummaryDataCell = styled.td<{
  width?: string
  textAlign?: string
}>`
  text-align: ${props => props.textAlign || 'center'};
  border: 1px solid grey;
  color: black;
  width: ${props => props.width || 'auto'};
  font-weight: ${props => (props.textAlign === 'left' ? 'bold' : 'normal')};
`

export const SummaryFooterRow = styled.tr`
  background-color: #dddddd;
`

export const SummaryFooterCell = styled.td<{ textAlign?: string }>`
  padding: 4px;
  border: 1px solid grey;
  color: black;
  text-align: ${props => props.textAlign || 'left'};
`

export const SummaryCommentsRow = styled.tr``

export const SummaryCommentsCell = styled.td`
  width: 600px;
  vertical-align: top;
`

export const GlobalStyles = `
  #root {
    background-color: #ffffff !important;
    background: #ffffff !important;
  }
  
  body {
    margin: 4px !important;
  }
  .LabelHeader
  {
      FONT-WEIGHT: bold;
      FONT-SIZE: 14px;
      COLOR: #000000;
      FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida
  }

  .LabelSubHeader
  {
      FONT-WEIGHT: bold;
      FONT-SIZE: 14px;
      COLOR: #000000;
      FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida
  }

  .mini
  {
    FONT-WEIGHT: normal;
      FONT-SIZE: 10px;
      COLOR: #000000;
      FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida
  }
  
  
  .lblStyleBox{font-family: Verdana; font-size: 10px; color: #000000;}
  .lblStyleHeader{font-family: Verdana; font-size: 12px; color: #000000;font-weight: bold;}
  

  .bottomBorder {border-bottom: 1px solid #000000;}
  .ButtonStacked {font-family: Verdana; font-size: 10px; font-weight: bold; background: #DDDDDD; border-bottom: 1px solid #00214C; border-right: 1px solid #00214C; border-left: 1px solid #00214C; border-top:1px solid #00214C; color:#000000; height:20px; text-decoration:none; cursor:hand; margin-right: 4px}
  .mandatoryAuditPoint { border-style:none;FONT-WEIGHT: bolder;FONT-SIZE: 11px;COLOR: #000000;FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida;background-color:Transparent;}
  .developmentAuditPoint { border-style:none;FONT-WEIGHT: bolder; font-style:italic; font-size: 11px;COLOR: Gray;FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida;border:thin;}
  .mandatoryCheckPoint { FONT-WEIGHT: normal;FONT-SIZE:9px;COLOR: #000000;FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida;background-color:Transparent;}
  .developmentCheckPoint { FONT-WEIGHT: normal; font-style:italic; font-size: 9px;COLOR: Gray;FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida;border:thin;}
  .pledge{ border:0; border-style:none; font-weight:bolder; font-size: 16px;COLOR: #000000; FONT-FAMILY: Trebuchet MS, Verdana, Arial, Geneva, Lucida; background-color:#DDDDDD;}
  .cbStyle{font-family: Verdana; font-size: 10px; font-weight: normal; PADDING-RIGHT: 0px; PADDING-LEFT: 0px; PADDING-BOTTOM: 0px; MARGIN: 0px; PADDING-TOP: 0px; HEIGHT: 10px;}
  
  .commentTable
  {
    page-break-after:always;
  }
  .footer-logo-dark {
      width: 206px;
      height: auto;
      margin-top: 10px;
  }
  #printDiv {
      overflow: auto;
      height: 100%;
  }      
`
